import * as types from '../actiontypes';
import {getAllFormUsersUrl} from '../apiUrls';

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request for all of the active users in the engagement plus the guest users with access to the document.
 * @param {Number} engagementId The Engagement ID.
 * @param {String} documentId The Document ID.
 * @returns {Object} An action object.
 */
export const getActiveAndGuestFormUsers = (engagementId, documentId) => {
	const url = getAllFormUsersUrl(engagementId, documentId);

	return {
		type: types.GET_FORM_USERS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};